import { memo } from 'react';
import { Handle, type NodeProps, Position } from 'reactflow';
// Import UI Components
import BaseBlock from './Base.block';

const ActionBlock: React.FC<NodeProps> = (props) => {
    const { sourcePosition, targetPosition, id } = props;

    return (
        <div className="crm-flow-editor-block">
            <Handle type="target" position={targetPosition ?? Position.Left} id={`${id}_target`} />
            <BaseBlock node={props} />
            <Handle type="source" position={sourcePosition ?? Position.Right} id={`${id}_source`} />
        </div>
    );
};

export default memo(ActionBlock);
